import { ApiNoteInProgress, useGetByTenantNoteInprogressQuery } from 'api/rtk-api'
import InfoIcon from 'assets/information.svg?react'
import clsx from 'clsx'
import { LearnMoreNoteApprovalModal, Rule } from 'components/core-v2'
import { TablePagination } from 'components/core-v2/molecules/table-pagination'
import { useState } from 'react'
import { Link, useParams } from 'react-router-dom'
import { getNoteStatusColor } from 'utilities/mappers/noteStatusColorMapper'
import { plural } from 'utilities/plural'
import { sentenceCase } from 'utilities/string'

import { PATH, TENANT } from '../../../const'
import classes from './note-list.module.scss'

interface Props {
  note: ApiNoteInProgress
}
const NoteCard = ({ note }: Props) => {
  const { '*': splat } = useParams()

  const [noteIdParam] = splat.split('/')

  return (
    <Link
      className={clsx(classes.noteCard, {
        [classes.active]: note.noteId === noteIdParam
      })}
      to={PATH.noteApprovalsSingleNote(note.noteId, 'activation')}
    >
      <div>
        <span className={classes.chip}>
          {note.ongoingInstructionType === 'Deposit' ? 'TOP UP' : 'WITHDRAW'}
        </span>
        <span className={classes.noteName}>{note.noteName}</span>
      </div>
      <span className={classes.clientName}>{note.client}</span>
      <span className={classes.noteStatus}>
        <span
          className={clsx(classes.noteStatusIcon)}
          style={{ background: getNoteStatusColor(note.noteStatus) }}
        />
        {note.noteStatus === 'PendingCommitment'
          ? 'Pending business unit commitment'
          : sentenceCase(note.noteStatus)}
      </span>
    </Link>
  )
}

const PAGE_SIZE = 20
export const NotesList = () => {
  const [pageNumber, setPageNumber] = useState(1)
  const { data, isLoading } = useGetByTenantNoteInprogressQuery({
    tenant: TENANT,
    pageSize: PAGE_SIZE,
    pageNumber
  })

  const [isModalShowing, setIsModalShowing] = useState(false)

  if (isLoading) return null

  return (
    <section>
      <div className={classes.headerWrapper}>
        <span className={classes.notesFound}>
          {data.totalDocuments} {plural('note', data.totalDocuments)} found
        </span>
        <button
          className={classes.learnMoreButton}
          type="button"
          onClick={() => setIsModalShowing(true)}
        >
          <InfoIcon className="mr-1" />
          Learn about the approval process
        </button>
      </div>
      <Rule />
      <TablePagination
        className="my-4"
        pagination={{
          pageNumber,
          pageSize: PAGE_SIZE,
          totalRows: data.totalDocuments
        }}
        variant="modern"
        onChange={({ pageNumber: newPageNumber }) => {
          setPageNumber(newPageNumber)
        }}
      />
      <Rule className="mb-8" />
      <ul>
        {data.data.map(note => (
          <NoteCard key={note.noteId} note={note} />
        ))}
      </ul>
      <LearnMoreNoteApprovalModal
        isOpen={isModalShowing}
        onClose={() => setIsModalShowing(false)}
      />
    </section>
  )
}
